import { BarChart3, CreditCard } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { billingWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  billingWeb,
  {
    BillingDetailsPage: () => import('./BillingDetailsPage'),
    BillingUsagePage: () => import('./BillingUsagePage'),
    BillingDelinquencyBanner: () => import('./BillingDelinquencyBanner'),
    BillingAdminSetupPanel: () => import('./BillingAdminSetupPanel'),
  },
  {
    icons: { BarChart3, CreditCard },
  },
);
